import React, { Component } from "react"
import MetaTags from 'react-meta-tags';

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import { Col, Container, Row, Button, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

class BirthChartPaymentFail extends Component {
    constructor(props) {
        super(props)

        this.goToGenerateReport = this.goToGenerateReport.bind(this)
    }

    goToGenerateReport() {
        this.props.history.push("/generate-birthchart")
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Payment Fail | Kattam</title>
                    </MetaTags>
                    <Container fluid className="p-0">
                        <Card>
                            <CardBody>
                                <div className="auth-full-page-content p-md-2 p-4">
                                    <div className="w-100">
                                        <div className="d-flex flex-column h-75">
                                            {/* <div className="mb-4 mb-md-2 text-center">
                                                <img
                                                    src={logodark}
                                                    alt=""
                                                    height="80"
                                                    className="auth-logo-dark"
                                                />

                                            </div> */}
                                            <div className="my-auto">
                                                <div className="text-center">
                                                    <div className="avatar-md mx-auto">
                                                        <div className="avatar-title rounded-circle bg-danger">
                                                            <i className="bx bxs-like bx-flip-vertical bx-lg"></i>
                                                        </div>
                                                    </div>

                                                    <div className="p-2 mt-4">
                                                        <h1 className="text-danger">
                                                            Payment failed!
                                                </h1>
                                                    </div>
                                                </div>
                                                <div className="mt-1 text-center">
                                                    <p>
                                                        Please contact kattam support
                                                <br></br>
                                                or click here to try again
                                            </p>
                                                    <div>
                                                        {/* <button
                                                            type="button"
                                                            className="btn btn-danger waves-effect waves-light mt-2 me-1"
                                                            onClick={this.goToGenerateReport}
                                                        >
                                                            Try again
                                            </button> */}
                                                        <button
                                                            type="button"
                                                            className="ml-1 btn btn-lg btn-danger waves-effect waves-light mt-2"
                                                            onClick={this.goToGenerateReport}
                                                        >
                                                            Back to Generate Report
                                            </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="mt-4 mt-md-5 text-center">
                                                <p className="mb-0">
                                                                            Copyright © {new Date().getFullYear()} Kattam Intelligence Pte. Ltd. All rights reserved.{" "}
                                                </p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment >
        )
    }
}

export default BirthChartPaymentFail;
